<template>
  <div>
    <div class="grid grid-cols-12 gap-3">
      <div class="grid gap-5 col-span-12 md:col-span-9 ">
        <HomeBanner class="h-40 md:h-85" />
        <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
          <HomeMenuCard
            v-for="menu in homeMenus"
            :menu="menu"
          />
        </div>
        <div class="flex gap-2">
          <HomeMenuCard2
            v-for="menu in homeMenus2"
            :menu="menu"
          />
        </div>
      </div>
      <div class="grid gap-5 col-span-12 md:col-span-3">
        <div v-if="$q.screen.gt.sm">
          <div class="nav-title mb-1">
            실시간 IN PLAY
          </div>
          <HomeHotGameCard />
        </div>
        <div>
          <div class="nav-title mb-1">
            공지/규정
          </div>
          <HomeAnnouncementCard />
        </div>
        <div>
          <div class="nav-title mb-1">
            오늘의 이벤트
          </div>
          <HomeEventCard />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import HomeBanner from '@/components/Banners/HomeBanner.vue'
import HomeAnnouncementCard from '@/components/Cards/HomeAnnouncementCard.vue'
import HomeEventCard from '@/components/Cards/HomeEventCard.vue'
import HomeHotGameCard from '@/components/Cards/HomeHotGameCard.vue'
import HomeMenuCard from '@/components/Cards/HomeMenuCard.vue'
import HomeMenuCard2 from '@/components/Cards/HomeMenuCard2.vue'
import { useAnnouncementStore } from '@/stores/announcement.js'
import { useEventStore } from '@/stores/event.js'
import link1 from '@/assets/home/link-1.png'
import link2 from '@/assets/home/link-2.png'
import link3 from '@/assets/home/link-3.png'
import link4 from '@/assets/home/link-4.png'
import link5 from '@/assets/home/link-5.png'
import link6 from '@/assets/home/link-6.png'

const announcementStore = useAnnouncementStore()
const eventStore = useEventStore()
announcementStore.fetch()
eventStore.fetch()

const homeMenus = [
  {
    en: 'EUROPEAN SPORTS',
    ko: '유럽형스포츠',
    descriptions: [
      '다양한 구성, 완벽한 피드 ',
      '3가지종류의 배당조절 ',
      'API연동 자동배당조절',
    ],
    img: link1,
    route: { name: 'pregames' },
  },
  {
    en: 'LIVE IN PLAY',
    ko: '실시간 LIVE',
    descriptions: [
      '정품 BET365 api연동 ',
      '0.5초의 LET속력 ',
      '축.야.농.배.하.E스포츠 진행',
    ],
    img: link2,
    route: { name: 'lives' },
  },
  {
    en: 'MINI GAME',
    ko: '미니게임',
    descriptions: [
      '파워볼..등 15가지 종목 ',
      '다양한 피드',
    ],
    img: link3,
    route: { name: 'mini-games' },
  },
  {
    en: 'VIRTUAL GAME',
    ko: '가상게임',
    descriptions: [
      'BET365의 가상 스포츠 ',
      '축구,개경주,외...',
    ],
    img: link4,
    route: { name: 'virtual-games' },
  },
]

const homeMenus2 = [
  {
    en: 'LIVE CASINO',
    ko: '라이브 카지노',
    descriptions: [
        'A사 최고급 품질 에볼루션 포함.',
        '10종의 카지노 런칭'
    ],
    img: link5,
    route: { name: 'casinos' },
  },
  {
    en: 'SLOT GAME',
    ko: '슬롯게임',
    descriptions: ['27종의 슬롯 런칭'],
    img: link6,
    route: { name: 'slots' },
  },
]
</script>
